var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleSolidGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 90,
    viewBox: "0 0 92 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 45,
    r: 43,
    fill: "#C5EEBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5014_141085",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 25,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 25,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5014_141085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6781 56.0142C41.2922 56.3803 40.6873 56.3803 40.3015 56.0142L30.0979 46.3324C29.6823 45.9381 29.6823 45.2759 30.0979 44.8816L31.5591 43.4951C31.945 43.1289 32.5499 43.1289 32.9358 43.4951L40.3015 50.4841C40.6873 50.8502 41.2923 50.8502 41.6781 50.4841L59.0643 33.9871C59.4501 33.621 60.055 33.621 60.4409 33.9871L61.9022 35.3736C62.3177 35.768 62.3177 36.4301 61.9022 36.8245L41.6781 56.0142Z",
    fill: "#108A00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSolidGreen);
export default __webpack_public_path__ + "static/media/check-circle-solid-green.017e258bf770d31617ea10d2dabb81af.svg";
export { ForwardRef as ReactComponent };